<div class="grid flex header-gap">
  <form [formGroup]="editAccountForm" (ngSubmit)="onEditAccountSubmit()">
    <div class="grid w-full pb-5">
      <div class="md:col-9">
        <h1 class="header">{{ 'Header.Accounts' | translate }}</h1>
        <div class="yellow-underline"></div>
      </div>
    </div>
    <div class="grid w-full pb-3">
      <div class="md:col-9">
        <h4>{{ 'Accounts.EditAccount' | translate }}</h4>
      </div>
    </div>

    <div class="md:col-5 p-0">
      <h6 class="mb-3">{{ 'Accounts.Mainportaluser' | translate }}</h6>
      <div class="grid w-full m-0">
        <div class="md:col-6 pl-0 mb-2">
          <p-floatlabel class="flex flex-column">
            <input pInputText id="firstName" formControlName="firstName" class="w-full" />
            <label for="firstName">{{ 'Accounts.FirstName' | translate }}</label>
          </p-floatlabel>
          @if (
              editAccountForm.controls.firstName.invalid &&
              (editAccountForm.controls.firstName.dirty || editAccountForm.controls.firstName.touched)
            ) {
<div
           >
            @if (editAccountForm.controls.firstName.hasError('required')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.FirstNameRequired' | translate }}" />
}

            @if (editAccountForm.controls.firstName.hasError('maxLengthExceeded')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.ExceedTestLimit' | translate }}" />
}

            @if (editAccountForm.controls.firstName.hasError('pattern')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.MinCharacters' | translate }}" />
}

            @if (editAccountForm.controls.firstName.hasError('invalidTextInput')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.AllowCharacter' | translate }}" />
}
          </div>
}
        </div>
        <div class="md:col-6 mb-2">
          <p-floatlabel class="flex flex-column">
            <input pInputText id="lastName" formControlName="lastName" class="w-full" />
            <label for="lastName">{{ 'Accounts.LastName' | translate }}</label>
          </p-floatlabel>
          @if (
              editAccountForm.controls.lastName.invalid &&
              (editAccountForm.controls.lastName.dirty || editAccountForm.controls.lastName.touched)
            ) {
<div
           >
            @if (editAccountForm.controls.lastName.hasError('required')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.LastNameRequired' | translate }}" />
}

            @if (editAccountForm.controls.lastName.hasError('pattern')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.MinCharacters' | translate }}" />
}

            @if (editAccountForm.controls.lastName.hasError('maxLengthExceeded')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.ExceedTestLimit' | translate }}" />
}

            @if (editAccountForm.controls.lastName.hasError('invalidTextInput')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.AllowCharacter' | translate }}" />
}
          </div>
}
        </div>
        <div class="md:col-12 pl-0 mb-2">
          <p-floatlabel class="flex flex-column">
            <input pInputText id="email" formControlName="email" class="w-full" />
            <label for="email">{{ 'Accounts.Email' | translate }}</label>
          </p-floatlabel>
        </div>
        <div class="md:col-12 pl-0 mb-2">
          <p-floatlabel class="flex flex-column">
            <p-select id="MedicalSpecialty"
              [options]="(medicalSpecialties$ | async) ?? []"
              optionLabel="name"
              optionValue="id"
              aria-describedby="medical-help"
              inputId="MedicalSpecialty"
              formControlName="medicalSpecialty"
              class="w-full" />
            <label for="medicalSpecialty">{{ 'Accounts.MedicalSpecialty' | translate }}</label>
          </p-floatlabel>
          @if (
              editAccountForm.controls.medicalSpecialty.touched &&
              editAccountForm.controls.medicalSpecialty.hasError('required')
            ) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
            icon="pi pi-info-circle"
            text="{{ 'Accounts.MedicalSpecialtyRequired' | translate }}" />
}
        </div>
        <div class="md:col-12 pl-0 mb-2">
          <p-floatlabel class="flex flex-column">
            <input pInputText id="doctorId" formControlName="doctorId" class="w-full" />
            <label for="doctroID">{{ 'Accounts.DoctorID' | translate }}</label>
          </p-floatlabel>
          @if (
              editAccountForm.controls.doctorId.invalid &&
              (editAccountForm.controls.doctorId.dirty || editAccountForm.controls.doctorId.touched)
            ) {
<div
           >
            @if (editAccountForm.controls.doctorId.hasError('invalidDigitCharacterInput')) {
<p-message styleClass="justify-content-start align-items-center p-inline-message-validation mt-2"
              icon="pi pi-info-circle"
              text="{{ 'Accounts.AllowDigitChar' | translate }}" />
}
          </div>
}
        </div>
        <div class="md:col-12 pl-0 mb-2">
          <p-floatlabel class="flex flex-column">
            <p-select formControlName="role"
              id="role"
              [options]="roles()"
              optionLabel="name"
              optionValue="id"
              inputId="role"
              class="w-full" />
            <label for="userRole">{{ 'Accounts.Userrole' | translate }}</label>
          </p-floatlabel>
        </div>
        <div class="md:col-12 pl-0 mb-2">
          @if (isQualifiedProfessionalVisible) {
<div class="field-checkbox">
            <p-checkbox [binary]="true"
              inputId="checkbox"
              title="test"
              formControlName="isQualifiedProfessional"
              class="pb-2" />
            <label for="checkbox" class="ml-2">{{ 'Accounts.Thispersonis' | translate }}</label>
          </div>
}
        </div>
      </div>
    </div>

    <div class="md:col-12 pl-0">
      <div class="flex justify-content-between">
        <p-button label="{{ 'Accounts.Save' | translate }}"
          styleClass="p-button-rounded"
          [disabled]="!editAccountForm.valid"
          [loading]="saveInProgress"
          type="submit"
          class="p-2 px-0" />
        <p-button label="{{ 'Accounts.Cancel' | translate }}"
          styleClass="p-button-outlined p-button-rounded"
          (onClick)="onEditAccountCancel()"
          class="p-2 pr-0" />
      </div>
    </div>
  </form>
</div>
